module.exports = __webpack_public_path__ + "static/media/footer-logo.62b13218.png";